import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class BnTransactionsDeleteIdsInterceptor implements HttpInterceptor {
  constructor() {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (request.url.indexOf('transaction-manager/client-api/v2/transactions/export') > -1 && request.method === 'GET') {
      const params = request.params;
      if (params.has('arrangementsIds')) {
        const arrangementIds = this.getFirstArrangementId(params.getAll('arrangementsIds'));

        const modifiedParams = request.params.set('arrangementsIds', arrangementIds);
        const clonedRequest = request.clone({
          params: modifiedParams
        });
        return next.handle(clonedRequest);
      }
    }

    if (request.url.indexOf('transaction-manager/client-api/v2/transactions') > -1 && request.method === 'GET') {
      const params = request.params;
      if (params.has('arrangementsIds')) {
        const arrangementIds = this.getFirstArrangementId(params.getAll('arrangementsIds'));

        const modifiedParams = request.params.set('arrangementsIds', arrangementIds);
        const clonedRequest = request.clone({
          params: modifiedParams
        });
        return next.handle(clonedRequest);
      }
    }

    return next.handle(request);
  }

  getFirstArrangementId(arrangementIds: string[]): string | null {
    if (arrangementIds && arrangementIds.length > 0) {
      return arrangementIds[0];
    }
    return null;
  }
}
